import React, { useCallback } from 'react';
/** REDUX */
import { deleteDictionaryItemAction } from '../../../../redux/slices/dictionary';
/** APOLLO */
import { useMutation } from '@apollo/client';
import deleteScheduleMutation from '../../../../utils/apollo/scheduler/deleteScheduleMutation';
/** COMPONENTS */
/** UTILS */
import {
  IDeleteScheduleMutation,
  IDeleteScheduleMutationVariables,
  ScheduleType,
} from '../../../../utils/apollo/graphqlSchema';
import { DictionaryTypeEnum } from '../../../../utils/interfaces';
import { useAppDispatch, useAppSelector } from '../../../../redux/hooks';
import { selectModalData } from '../../../../redux/selectors/modal';
import { closeModal } from '../../../../redux/slices/modal';
import printGraphqlErrors from '../../../../utils/apollo/printGraphqlErrors';
import ConfirmationModal from '../../../../components/ConfirmationModal';
import toastMessage from '../../../../utils/toastMessage';

interface IProps {
  type: ScheduleType;
}

const scheduleTypeToDictionary = {
  [ScheduleType.Analysis]: DictionaryTypeEnum.ScheduleAnalysis,
  [ScheduleType.Dashboard]: DictionaryTypeEnum.ScheduleDashboard,
  [ScheduleType.BrazeCohortImport]: DictionaryTypeEnum.ScheduleCohort,
};

export default ({ type }: IProps) => {
  const dispatch = useAppDispatch();
  const currentSchedule = useAppSelector(selectModalData);

  const handleClose = useCallback(() => {
    dispatch(closeModal());
  }, [dispatch]);

  const onDeleteSchedule = useCallback(
    ({ deleteSchedule }: IDeleteScheduleMutation) => {
      const { errors } = deleteSchedule;
      if (printGraphqlErrors(errors)) {
        return;
      } else {
        toastMessage({
          message: `${currentSchedule.name} has been deleted.`,
          type: 'info',
        });
      }

      dispatch(
        deleteDictionaryItemAction({
          itemId: currentSchedule.id,
          dictionaryType: scheduleTypeToDictionary[type],
        }),
      );
      handleClose();
    },
    [dispatch, handleClose, currentSchedule, type],
  );
  const [deleteSchedule, { loading }] = useMutation<
    IDeleteScheduleMutation,
    IDeleteScheduleMutationVariables
  >(deleteScheduleMutation, {
    variables: {
      id: currentSchedule.id,
    },
    onCompleted: onDeleteSchedule,
  });

  return (
    <ConfirmationModal
      open
      onClose={handleClose}
      onSubmit={deleteSchedule}
      header={'Delete Confirmation'}
      confirmActionLabel={'Delete'}
      disabled={loading}
      trackContext="schedules"
      trackConfirmAction="delete - confirm"
      trackCancelAction="delete - cancel"
    >
      {ScheduleType.BrazeCohortImport === type
        ? 'Do you want to delete this cohort import schedule: '
        : 'Do you want to delete '}
      <strong>{currentSchedule.name}</strong>?{' '}
      {ScheduleType.BrazeCohortImport === type
        ? 'Kubit will stop importing this cohort to Braze. '
        : 'Once deleted, you won’t receive any email about this in the future.'}
    </ConfirmationModal>
  );
};
